<template>

	<v-rating 
		hover
		:length="length"
		:value="value"
		:readonly="!readonly"
		@input="update"
	>

		<template v-slot:item="props">
			<v-icon 
				size="20"
				color="#bfbfbf"
				@click="props.click"
			>
				{{ props.isFilled

				? [
				'mdi-numeric-1-box'
				,'mdi-numeric-2-box'
				,'mdi-numeric-3-box'
				,'mdi-numeric-4-box'
				,'mdi-numeric-5-box'
				,'mdi-numeric-6-box'
				,'mdi-numeric-7-box'
				][props.index] 

				:'mdi-checkbox-blank-outline'
				
				}} }}
			</v-icon>
		</template>
	</v-rating>

</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator';

/* @Component */
/* export default class serviceProgramming extends Vue { */
/*   @Prop() private descr!: array; */
/*   @Prop() private details!: array; */
/* } */

export default {
	name: 'rating',

	props: ['value', 'length', 'readonly']

	,data: function(){
		return {
		};
	}

	,methods: {
		update: function(newVal){
			this.$emit('input', newVal);
		}
	}
	,mounted(){}
	,beforeDestroy(){}
	,computed: {}
	,beforeCreate(){}
	,components: {}

}
</script>

